import { Link } from 'react-router-dom'
import { KPI_LOADING_DISPLAY } from '../../lib/managerial-kpis'
import type { RecentOrderStatus, RecentOrderView } from '../../lib/recent-orders'
import styles from './RecentOrdersPanel.module.css'

interface RecentOrdersPanelProps {
  orders: RecentOrderView[]
  isLoading: boolean
  isBusy?: boolean
  hasData?: boolean
}

const STATUS_CLASS: Record<RecentOrderStatus, string> = {
  paid: styles.statusPaid,
  pending: styles.statusPending,
  canceled: styles.statusCanceled,
}

export function RecentOrdersPanel({
  orders,
  isLoading,
  isBusy = false,
  hasData = true,
}: RecentOrdersPanelProps) {
  const showEmptyRecorte = hasData && orders.length === 0

  return (
    <section
      className={styles.card}
      aria-labelledby="recent-orders-title"
      aria-busy={isLoading || isBusy}
    >
      <div className={styles.header}>
        <h2 id="recent-orders-title" className={styles.title}>
          Últimos Pedidos
        </h2>
        <Link to="/pedidos/lista" className={styles.seeAll}>
          Ver todos
        </Link>
      </div>

      {isLoading ? (
        <p className={styles.empty}>Carregando pedidos...</p>
      ) : showEmptyRecorte ? (
        <p className={styles.empty}>Nenhum pedido no recorte.</p>
      ) : orders.length === 0 ? (
        <p className={styles.empty}>{KPI_LOADING_DISPLAY}</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Data</th>
                <th scope="col">Cliente</th>
                <th scope="col">Valor</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td className={styles.idCell}>{order.id}</td>
                  <td>
                    <div className={styles.dateCell}>
                      <span>{order.dateLabel}</span>
                      <span className={styles.time}>{order.timeLabel}</span>
                    </div>
                  </td>
                  <td className={styles.nameCell}>{order.customerName}</td>
                  <td className={styles.amountCell}>{order.formattedAmount}</td>
                  <td>
                    <span className={`${styles.status} ${STATUS_CLASS[order.status]}`}>
                      {order.statusLabel}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
